import decode from 'jwt-decode';
import { message } from 'antd';

const TOKEN_KEY = 'TI_Token_Key789';
const USERCODE_KEY = 'TI_UserCode_Key789';
const ResponseStatusesOk = 1;
const ResponseStatusesNo = 2;
const ResponseStatusesError = 3;
const ResponseStatusesSessionClosed = 4;


export const sendConnectionOrder = (request, onReceive) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(request)
    };
    fetch(window.configTI.URL_BACKEND + '/common/connectionorder', requestOptions)
        .then(response => response.json())
        .then(data => {
            if (data.bodyStatus && data.bodyStatus == 1) {
                onReceive(data.body);
            }
            else if (data.bodyStatus && data.bodyStatus == 3) {
                message.error(data.message);
            }
            else {
                message.error('Ответ не получен.');
            }
        })
        .catch(error => {
            message.error('Ошибка:' + error);
            console.log(error);
        });
}

export const sendContractOrder = (request, onReceive) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(request)
    };
    fetch(window.configTI.URL_BACKEND + '/common/contractorder', requestOptions)
        .then(response => response.json())
        .then(data => {
            if (data.bodyStatus && data.bodyStatus == 1) {
                onReceive(data.body);
            }
            else if (data.bodyStatus && data.bodyStatus == 3) {
                message.error(data.message);
            }
            else {
                message.error('Ответ не получен.');
            }
        })
        .catch(error => {
            message.error('Ошибка:' + error);
            console.log(error);
        });
}

export const sendEquipmentOrder = (request, onReceive) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(request)
    };
    fetch(window.configTI.URL_BACKEND + '/common/equipmentorder', requestOptions)
        .then(response => response.json())
        .then(data => {
            if (data.bodyStatus && data.bodyStatus == 1) {
                onReceive(data.body);
            }
            else if (data.bodyStatus && data.bodyStatus == 3) {
                message.error(data.message);
            }
            else {
                message.error('Ответ не получен.');
            }
        })
        .catch(error => {
            message.error('Ошибка:' + error);
            console.log(error);
        });
}

export const sendFeedback = (request, onReceive) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(request)
    };
    fetch(window.configTI.URL_BACKEND + '/common/feedback', requestOptions)
        .then(response => response.json())
        .then(data => {
            if (data.bodyStatus && data.bodyStatus == 1) {
                onReceive(data.body);
            }
            else if (data.bodyStatus && data.bodyStatus == 3) {
                message.error(data.message);
            }
            else {
                message.error('Ответ не получен.');
            }
        })
        .catch(error => {
            message.error('Ошибка:' + error);
            console.log(error);
        });
}



export const newsFetch = (request, onReceive) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(request)
    };
    fetch(window.configTI.URL_BACKEND + '/common/news', requestOptions)
        .then(response => response.json())
        .then(data => {
            if (data.bodyStatus && data.bodyStatus == 1) {
                onReceive(data.body);
            }
            else if (data.bodyStatus && data.bodyStatus == 3) {
                message.error(data.message);
            }
            else {
                message.error('Ответ не получен.');
            }
        })
        .catch(error => {
            message.error('Ошибка:' + error);
            console.log(error);
        });
}

export const loginAuth = (url, user, password) => {
    removeToken();
    return fetchAuth(url, {
            method: 'POST',
            body: JSON.stringify({
                user,
                password
            })
        })
        .then(res => {
            if (res.bodyStatus && res.bodyStatus === 1) {
                const token = res.body.token;
                const code = res.body.code;
                if (token) {
                    setToken(token, code)
                }
                else {
                    removeToken();
                }
            }
            return Promise.resolve(res);
        })
        .catch(err => {
            removeToken();
            return Promise.reject(err);
        });
}

export const getDate = (date) =>{
    const DATE_OPTIONS = { year: "numeric", month: "long", day: "numeric" };
    return new Date(date).toLocaleDateString("ru-RU", DATE_OPTIONS);
}

export const convertToPlain = (html) =>{

    // Create a new div element
    var tempDivElement = document.createElement("div");

    // Set the HTML content with the given value
    tempDivElement.innerHTML = html;

    // Retrieve the text property of the element 
    return tempDivElement.textContent || tempDivElement.innerText || "";
}

const selfStorage = {};


const storageAvailable = function (type) {
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    }
    catch (e) {
        return e instanceof DOMException && (
            // everything except Firefox
            e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            (storage && storage.length !== 0);
    }
}
const useLocalStorage = storageAvailable('localStorage');

const saveItemToStorage = (id, value) => {
    if (useLocalStorage) {
        localStorage.setItem(id, value);
    }
    else {
        selfStorage[id] = value;
    }
}

const getItemFromStorage = (id) => {
    if (useLocalStorage) {
        return localStorage.getItem(id);
    }
    else {
        return selfStorage[id];
    }
}

const removeItemFromStorage = (id) => {
    if (useLocalStorage) {
        localStorage.removeItem(id);
    }
    else {
        selfStorage[id] = null;
    }
}

const loggedIn = () =>{
    const token = getToken();
    return !!token && !isTokenExpired(token);
}

const isTokenExpired = (token) =>{
    try {
        const decoded = decode(token.access_token);
        console.log('EXP :', decoded.exp);
        console.log('NOW :', Date.now() / 1000);
        if (decoded.exp < Date.now() / 1000) {
            return true;
        }
        else {
            return false;
        }
    }
    catch (err) {
        console.log(err);
        return false;
    }
}


const setToken = (token, code) => {
    saveItemToStorage(TOKEN_KEY, JSON.stringify(token));
    if (code) {
        saveItemToStorage(USERCODE_KEY, code);
    }
    console.log('SET ' + TOKEN_KEY, token);
}

const getToken = () => {
    //console.log('GET' + TOKEN_KEY);
    const jsonToken = getItemFromStorage(TOKEN_KEY);
    if (jsonToken) {
        const token = JSON.parse(jsonToken);
        console.log(token);
        return token;
    }
    else {
        //console.log('NO');
        return null;
    }

}

const removeToken = () => {
    removeItemFromStorage(TOKEN_KEY);
    removeItemFromStorage(USERCODE_KEY);
}

const getProfile = () =>{
    return decode(getToken());
}


export const fetchAuth = (url, options) => {
    const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
    const token = getToken();
    if (token) {
        const isBad = isTokenExpired(token);
        headers['credentials'] = "include";
        headers['Authorization'] = 'Bearer ' + token.access_token;
    }

    return fetch(url, {
        headers,
        ...options
    })
        .then(response => response.json());
}



const _checkStatus0 = (response) => {

    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        var error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
}

//'profile/refresh'
function refreshTokenQuery(url, token, refreshToken, fRefresh, fExit) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify({ token, refreshToken })
    };
    fetchAuth(url, requestOptions)
        .then(data => {
            if (data.bodyStatus == 1) {
                const token = data.body;
                if (!token) {
                    console.log('TOKEN_IS_NULL');
                }
                setToken(token, null);
                fRefresh(token.login, token.lifeMinute);
            }
            else {
                removeToken();
                fExit();
            }
        })
        .catch(error => {
            removeToken();
            console.log(error);
            fExit();
        });;

}

export function refreshTokenCycle(url, fRefresh, fExit) {
    const token = getToken();
    if (token !== null) {
        refreshTokenQuery(url, token.access_token, token.refresh_token, fRefresh, fExit);
    }
}

function delay(delay) {
    return new Promise(r => {
        setTimeout(r, delay);
    })
}

function isAuthenticated() {
    let result = false;
    const tokenValue = getItemFromStorage(TOKEN_KEY);
    if (tokenValue) {
        let token = JSON.parse(tokenValue);
        result = !isTokenExpired(token.access_token);
    }
    return result;
}

export function gotoWorkSite(fOk, fError) {
    //Получить идентификатор перехода.
    const requestOptions = {
        method: 'GET',
    };
    fetchAuth(window.configTI.URL_BACKEND + '/profile/share', requestOptions)
        .then(data => {
            if (data.bodyStatus == 1) {
                var url;
                if (window.configTI.IS_OLD_WORKSITE) {
                    url = getOldSiteUrl();
                }
                else {
                    url = window.configTI.URL_WORKSITE + "?u=" + data.body;
                }
                if (url) {
                    console.log('url', url);
                    fOk();
                    window.location.assign(url);
                    //window.location.replace(url);
                }
                else {
                    fError();
                }
            }
            else {
                fError();
            }
        })
        .catch(error => {
            console.log(error);
            fError(error);
        });
}


function getOldSiteUrl() {
    let result = null;
    const urlOld = window.configTI.URL_WORKSITE;
    const code = getUserCode();
    if (urlOld && urlOld.length > 0 && code) {
        result = urlOld + "Login.aspx?u=" + code;
    }
    return result;
}

const getUserCode = () => {
    try {
        const userCode = getItemFromStorage(USERCODE_KEY);
        if (userCode) {
            return userCode;
        }
        else {
            return null;
        }
    }
    catch (err) {
        console.log(err);
        return null;
    }
}
